import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base.service';
import { Observable } from 'rxjs';
import { FeedbackRequest } from '../models/feedback-request';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'feedback');
  }

  postFeedback(messageId: string, data: FeedbackRequest): Observable<void> {
    return this._http.post<void>(`${this._baseUrl}/${messageId}`, data);
  }

}
